<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <breadcrumb />
        </div>

        <template v-if="!loadingCards">
          <div class="bsd-section">
            <div class="z-title z-title--small spacer-bottom-s" v-if="cardFormVisible">
              Cadastre seu cartão de crédito
            </div>
            <div class="z-title z-title--small spacer-bottom-s" v-else>
              Selecione um cartão de crédito
            </div>

            <p class="z-text spacer-bottom-l" v-if="$route.query['first-config']">
              {{ student.first_name }}, precisamos que você nos informe um cartão de crédito como forma de
              pagamento das mensalidades do curso de {{ currentBilling.course_name }} na {{ institutionName }}.
            </p>
          </div>

          <alert-box ref="alertBox" class="spacer-bottom-l" />

          <template v-if="!cardFormVisible">
            <card-list
              :cards="cards"
              @cardSelected="definePaymentMethod"
              @cardRemoved="loadStudentCards"
            />

            <button class="z-button z-button--secondary z-button--block" @click="showCardForm">
              Cadastrar novo cartão de crédito
            </button>
          </template>

          <card-form :card-type="this.cardType" @cardCreated="definePaymentMethod" v-else />
        </template>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.payment-methods {
  display: flex;
  flex-direction: column;
  margin-top: var(--space-giant);
}

.payment-methods__action-card {
  align-items: center;
  cursor: pointer;
  display: flex;
  margin-bottom: var(--space-medium);
}

.payment-methods__action-card-icon {
  color: var(--color-primary);
  font-size: rem(24);
}

.payment-methods__action-card-text {
  margin-left: var(--space-medium);
}
</style>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import AlertBox from 'components/zilla/alert-box';
import Breadcrumb from 'components/breadcrumb';
import CardForm from 'components/card-form';
import CardList from 'components/card-list';
import RecurrentPaymentMethodService from 'services/RecurrentPaymentMethodService';

export default {
  props: {
    cardType: {
      type: String,
      required: true,
      validator: (cardType) => cardType === 'credit_card',
    },
  },
  components: {
    AlertBox,
    Breadcrumb,
    CardForm,
    CardList,
  },
  data() {
    return {
      loadingCards: true,
      cardFormVisible: true,
      whatsappNumber: '0800 291 7878',
    };
  },
  computed: {
    ...mapGetters([
      'permittedPaymentMethods',
    ]),
    ...mapState([
      'currentBilling',
      'studentCards',
      'student',
    ]),
    cards() {
      return this.studentCards.filter((card) => card.card_type === this.cardType);
    },
    canChangeDueDay() {
      return this.currentBilling.can_change_due_day;
    },
    institutionName() {
      return this.currentBilling.institution_name;
    },
  },
  methods: {
    ...mapActions([
      'loadStudentCards',
    ]),
    definePaymentMethod(card) {
      const paymentMethod = !card.card_type ? 'boleto' : card.card_type;

      this.$tracker.logEvent(`[payment configuration] Selected ${paymentMethod}`);
      this.$pageLoader.wrap(this.updatePaymentMethod(card), 'Salvando forma de pagamento');
    },
    updatePaymentMethod(card) {
      let enablePaymentMethodService = null;
      if (card.card_type === 'credit_card') {
        enablePaymentMethodService = RecurrentPaymentMethodService.enableCreditCard(this.currentBilling.id, card.id);
      } else {
        enablePaymentMethodService = RecurrentPaymentMethodService.enableBoleto(this.currentBilling.id);
      }
      return enablePaymentMethodService.then(() => {
        this.redirectToNextStep();
      }).catch(() => {
        this.$refs.alertBox.show(
          'danger', 'Erro inesperado',
          `Houve um problema ao configurar a forma de pagamento. \
          Por favor, entre em contato com o Quero Pago pelo Whatsapp: ${this.whatsappNumber}`,
        );
      });
    },
    redirectToNextStep() {
      if (this.canChangeDueDay) {
        this.$router.push({ name: 'payment-configuration-due-day' });
      } else {
        this.$router.push({ name: 'payment-configuration-confirmation' });
      }
    },
    showCardForm() {
      this.$refs.alertBox.hide();
      this.cardFormVisible = true;
    },
    goToCreditPaymentMethod() {
      this.$router.push({ name: 'payment-configuration-credit-card' });
    },
    showPaymentMethod(paymentMethod) {
      return this.permittedPaymentMethods.includes(paymentMethod);
    },
  },
  mounted() {
    this.loadStudentCards()
      .then(() => {
        if (this.cards.length > 0) {
          this.cardFormVisible = false;
        }
        this.loadingCards = false;
      })
      .catch(() => {
        this.loadingCards = false;
      });
  },
};
</script>
